import { PaperPlane } from "@/components/PaperPlane";

export const Eyebrow = ({ children, className = "" }) => (
  <span className={`label inline-flex items-center gap-2 text-[11px] sm:text-xs text-gold ${className}`}>
    <PaperPlane className="w-3.5 h-3.5" />
    {children}
  </span>
);

export const PageHero = ({ eyebrow, title, subtitle, children }) => (
  <section className="relative pt-40 pb-16 sm:pt-48 sm:pb-24 overflow-hidden" data-testid="page-hero">
    <div className="absolute top-0 right-0 w-[40rem] h-[40rem] bg-gold/5 blur-[120px] rounded-full pointer-events-none" />
    <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 relative">
      {eyebrow && <Eyebrow className="animate-fade-up">{eyebrow}</Eyebrow>}
      <h1 className="mt-6 font-display font-black text-4xl sm:text-5xl lg:text-7xl tracking-tighter text-white leading-[1.02] max-w-5xl animate-fade-up">
        {title}
      </h1>
      {subtitle && <p className="mt-7 text-lg sm:text-xl text-cream/70 max-w-2xl leading-relaxed animate-fade-up">{subtitle}</p>}
      {children}
    </div>
  </section>
);

export default PageHero;
